import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/spotium.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createBlock(_component_main_section, null, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "flex h-full items-center justify-center space-x-4" }, [
        _createElementVNode("div", { class: "flex items-center border-r-4 border-grey pr-4" }, [
          _createElementVNode("h2", { class: "text-8xl" }, "4"),
          _createElementVNode("img", {
            alt: "spotium logo",
            class: "rounded-full shadow-md",
            src: _imports_0,
            width: "100"
          }),
          _createElementVNode("h2", { class: "text-8xl" }, "4.")
        ]),
        _createElementVNode("h2", { class: "font-medium" }, "This page could not be found!")
      ], -1)
    ]))]),
    _: 1
  }))
}